module.exports = __webpack_public_path__ + "img/mt10.ceeab386.jpg";